const SvgComponent = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="image"
      aria-label="עיגול ריק"
    >
      <path
        d="M5.00245 9.374C7.42245 9.374 9.35845 7.438 9.35845 5.018C9.35845 2.598 7.42245 0.662 5.00245 0.662C2.58245 0.662 0.646449 2.598 0.646449 5.018C0.646449 7.438 2.58245 9.374 5.00245 9.374ZM5.00245 8.912C2.83545 8.912 1.10845 7.185 1.10845 5.018C1.10845 2.851 2.83545 1.124 5.00245 1.124C7.16945 1.124 8.89645 2.851 8.89645 5.018C8.89645 7.185 7.16945 8.912 5.00245 8.912Z"
        fill="#0089CF"
      />
    </svg>
  )
}

export default SvgComponent
